module.exports = __webpack_public_path__ + "img/Swap-Bridge-bg.4b5fc8f4.png";